import React, { useRef, useState } from 'react';
import { motion, useInView, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
import './Gallery.css';

const photos = [
  {
    src: 'https://customer-assets-jai6qajn.emergentagent.net/job_transition-homes-2/artifacts/jkw0ec4n_IMG_20260817_154740.webp',
    alt: 'Open living room and kitchen',
    caption: 'A place to gather',
    span: 'wide'
  },
  {
    src: 'https://customer-assets-jai6qajn.emergentagent.net/job_transition-homes-2/artifacts/uy10w0w2_IMG_20260817_154745.webp',
    alt: 'Private front entryway',
    caption: 'Your own front door',
    span: 'tall'
  },
  {
    src: 'https://customer-assets-jai6qajn.emergentagent.net/job_transition-homes-2/artifacts/ew055m62_IMG_20260817_154732.webp',
    alt: 'View of kitchen and dining from staircase',
    caption: 'Room to breathe',
    span: 'full'
  }
];

const Gallery = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-100px' });
  const [selected, setSelected] = useState(null);

  return (
    <section id="our-homes" className="gallery" ref={ref}>
      <div className="gallery-container">
        <motion.div
          className="gallery-header"
          initial={{ opacity: 0, y: 50 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
        >
          <span className="section-label">Our Homes</span>
          <h2 className="section-title">
            A real home,
            <br />
            <span className="highlight">not just a room</span>
          </h2>
        </motion.div>

        <div className="gallery-grid" data-testid="gallery-grid">
          {photos.map((photo, index) => (
            <motion.figure
              key={index}
              className={`gallery-item gallery-item-${photo.span}`}
              data-testid={`gallery-item-${index}`}
              initial={{ opacity: 0, y: 40 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.7, delay: 0.2 + index * 0.12 }}
              onClick={() => setSelected(photo)}
            >
              <img src={photo.src} alt={photo.alt} loading="lazy" />
              <figcaption className="gallery-caption">{photo.caption}</figcaption>
            </motion.figure>
          ))}
        </div>
      </div>

      <AnimatePresence>
        {selected && (
          <motion.div
            className="gallery-lightbox"
            data-testid="gallery-lightbox"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setSelected(null)}
          >
            <button
              className="lightbox-close"
              data-testid="lightbox-close-button"
              onClick={() => setSelected(null)}
              aria-label="Close"
            >
              <X size={28} />
            </button>
            <motion.img
              src={selected.src}
              alt={selected.alt}
              initial={{ scale: 0.92, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.95, opacity: 0 }}
              transition={{ duration: 0.3 }}
              onClick={(e) => e.stopPropagation()}
            />
          </motion.div>
        )}
      </AnimatePresence>
    </section>
  );
};

export default Gallery;
